import * as React from 'react'
import {
  useListToolbarButton,
  useListToolbarButtonState,
} from '@platejs/list-classic/react'
import { KEYS } from 'platejs'

import { ListIcon, ListOrderedIcon } from '../../../icons'
import { RichTextField } from '../../RichTextField'

type ListToolbarButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof RichTextField.ToolbarButton>,
  'children' | 'label'
>

type ListToolbarButtonInternalProps = ListToolbarButtonProps & {
  icon: React.ReactElement
  label: string
  nodeType: string
}

const ListToolbarButton = React.forwardRef<
  HTMLButtonElement,
  ListToolbarButtonInternalProps
>(({ icon, label, nodeType, onClick, ...props }, ref) => {
  const state = useListToolbarButtonState({ nodeType })
  const { props: listButtonProps } = useListToolbarButton(state)

  return (
    <RichTextField.ToolbarButton
      {...props}
      ref={ref}
      aria-pressed={state.pressed}
      label={label}
      onClick={(event) => {
        onClick?.(event)
        if (!event.defaultPrevented) listButtonProps.onClick()
      }}
    >
      {icon}
    </RichTextField.ToolbarButton>
  )
})

ListToolbarButton.displayName = 'RichTextField.ListToolbarButton'

const BulletedListToolbarButton = React.forwardRef<
  HTMLButtonElement,
  ListToolbarButtonProps
>((props, ref) => (
  <ListToolbarButton
    {...props}
    ref={ref}
    icon={<ListIcon />}
    label="Bulleted list"
    nodeType={KEYS.ulClassic}
  />
))

BulletedListToolbarButton.displayName =
  'RichTextField.BulletedListToolbarButton'

const NumberedListToolbarButton = React.forwardRef<
  HTMLButtonElement,
  ListToolbarButtonProps
>((props, ref) => (
  <ListToolbarButton
    {...props}
    ref={ref}
    icon={<ListOrderedIcon />}
    label="Numbered list"
    nodeType={KEYS.olClassic}
  />
))

NumberedListToolbarButton.displayName =
  'RichTextField.NumberedListToolbarButton'

export { BulletedListToolbarButton, NumberedListToolbarButton }
export type { ListToolbarButtonProps }
